import script from "./PaTour.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaTour.vue?vue&type=script&setup=true&lang=ts"

import "./PaTour.vue?vue&type=style&index=0&id=b3ecd9cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3ecd9cc"]])

export default __exports__